import React from 'react';
import PropTypes from 'prop-types';
import {
  chunk,
  sortBy,
  find,
} from 'lodash';
import {
  withStyles,
  Icon,
} from '@material-ui/core';

import StatusBadge from '../StatusBadge';
import styles from './styles';

const StatusBadgeListComponent = ({
  statuses,
  displayedStatuses,
  maxLength,
  statusIdField,
  classes,
  sortBy: sortByFields,
  mini,
  emptyListLabel,
  hideLabel,
}) => {
  if (!displayedStatuses || displayedStatuses.length === 0) {
    return emptyListLabel;
  }
  const [
    limitedStatuses,
    extraStatuses = [],
  ] = chunk(
    sortBy(displayedStatuses, sortByFields),
    displayedStatuses.length > maxLength
      ? maxLength - 1
      : maxLength,
  );

  return (
    <span className={classes.flexContainer}>
      {
        limitedStatuses.map((limitedStatus, index) => {
          const status = find(statuses, (availableStatus) => availableStatus.id === limitedStatus[statusIdField]) || {};
          return [
            <StatusBadge
              icon={status.icon}
              iconColor={status.iconColor}
              key={`status-${status[statusIdField]}-${Math.floor(Math.random() * 1000)}`}
              label={
                limitedStatuses.length === 1 && !hideLabel
                  ? status.name
                  : ''
              }
              mini={mini}
            />, (
              displayedStatuses[index + 1]
                ? <Icon className={classes.chevron} key={`status-${status[statusIdField]}-${Math.floor(Math.random() * 1000)}-chevron`}>chevron_right</Icon>
                : ''
            ),
          ];
        })
      }
      {
        extraStatuses.length > 0
          && (
            <span className={classes.accentColor}>+{extraStatuses.length}</span>
          )
      }
    </span>
  );
};

StatusBadgeListComponent.propTypes = {
  statuses: PropTypes.array,
  displayedStatuses: PropTypes.array,
  maxLength: PropTypes.number,
  statusIdField: PropTypes.string,
  classes: PropTypes.object,
  sortBy: PropTypes.array,
  mini: PropTypes.bool,
  emptyListLabel: PropTypes.string,
  hideLabel: PropTypes.bool,
};

StatusBadgeListComponent.defaultProps = {
  statuses: [],
  displayedStatuses: [],
  maxLength: 4,
  statusIdField: 'id',
  classes: {},
  sortBy: ['order'],
  mini: false,
  emptyListLabel: '',
  hideLabel: false,
};

export default withStyles(styles)(StatusBadgeListComponent);
